import { css } from 'styled-components';

/**
 * Standard focus ring for buttons, controls, and nav items. Renders a 2px
 * outline offset outside the element boundary. Use inside a styled-component
 * tagged template literal.
 *
 * @example
 * const Button = styled.button`
 *   ${focusRing}
 * `;
 */
export const focusRing = css`
  &:focus-visible {
    outline: ${(p) => p.theme.focus.width} solid ${(p) => p.theme.colors.brand.primary};
    outline-offset: ${(p) => p.theme.focus.offset};
  }
`;

/**
 * Inset focus ring for bordered inputs (TextInput, SearchInput, TimeInput).
 * Uses a negative offset so the ring sits inside the element's border,
 * avoiding a double-border appearance.
 *
 * @example
 * const Input = styled.input`
 *   ${focusRingInset}
 * `;
 */
export const focusRingInset = css`
  &:focus-visible {
    outline: ${(p) => p.theme.focus.width} solid ${(p) => p.theme.colors.brand.primary};
    outline-offset: ${(p) => p.theme.focus.insetOffset};
  }
`;
